var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStiftAktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stift-Aktiv__Icn/40px/Stift-Aktiv",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stift-Aktiv__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stift-Aktiv__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5532029,9.17434253 C24.8062276,6.92131777 28.4591025,6.92131777 30.7121273,9.17434253 L32.0175552,10.4797704 C34.2705799,12.7327952 34.2705799,16.3856701 32.0175552,18.6386948 L19.7490234,30.9072266 L7.08730639,34.892062 L10.1981798,21.5293656 Z M29.0663234,10.6933506 C27.6243875,9.25141473 25.2865476,9.25141473 23.8446118,10.6933506 L11.9092462,22.6287162 L9.75812906,31.8687981 L18.4629984,29.129243 L30.3717513,17.2204901 C31.8136871,15.7785543 31.8136871,13.4407143 30.3717513,11.9987785 Z M13.6261291,23.5218987 L17.5421291,27.4378987 L17.4781133,27.5027665 L12.2900709,29.135476 L13.5883189,23.5592319 L13.6261291,23.5218987 Z M22.3921291,14.7548987 L26.3091291,18.6718987 L18.8471291,26.1318987 L14.9311291,22.2158987 L22.3921291,14.7548987 Z M25.1500397,11.9987785 C25.8710076,11.2778106 27.0399276,11.2778106 27.7608955,11.9987785 L29.0663234,13.3042064 L29.1644143,13.4101524 L29.2672569,13.5418106 C29.779547,14.2626597 29.7125691,15.2688164 29.0663234,15.9150622 L27.6141291,17.3668987 L23.6971291,13.4498987 Z",
    id: ".._.._src_svg_Icn_40px_Stift-Aktiv__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStiftAktiv);
export default __webpack_public_path__ + "static/media/Stift-Aktiv.ef5f208dfafd4930de346fa1c68314a2.svg";
export { ForwardRef as ReactComponent };